import createEntityDuck from '../../util/genericEntityDuck';

const namespace = 'settings';
const storeKey = 'audits';

const duck = createEntityDuck(namespace, storeKey, 'auditEventId', namespace);

export { duck as default, storeKey };
export const { creators, reducer, types, selectors, initialState } = duck;
